import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Ideology.css";

export default function Ideology(props) {
  return (
    <div>
      <Container fluid className="ideology-fluid-container">
        <div
          style={{ background: props.fadeBG }}
          className="ideology-img-overlay"
        >
          <Container>
            <Row>
              <Col className="ideology-first-col">
                <h2 style={{ color: props.white, fontSize: props.titleSize }}>
                  IDEOLOGIA PARA INSPIRAR VIDAS
                </h2>
              </Col>
            </Row>
            <Row>
              <Col className="ideology-second-col">
                <p style={{ color: props.white, fontSize: props.textSize }}>
                  Essas são as diretrizes que norteiam nosso trabalho e
                  conquistam há mais de um século a confiança de milhares de
                  famílias.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
      <Container fluid>
        <Container className="ideology-container">
          <Row>
            <Col lg="6" xl="3">
              <div
                style={{ background: props.white }}
                className="ideology-card"
              >
                <div className="ideology-icon-negocio" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  NOSSO NEGÓCIO
                </h3>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Cuidar em vida e eternizar histórias
                </p>
              </div>
            </Col>
            <Col lg="6" xl="3">
              <div
                style={{ background: props.white }}
                className="ideology-card"
              >
                <div className="ideology-icon-missao" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  NOSSA MISSÃO
                </h3>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Cuidar de quem é importante para você com humanidade,
                  dignidade e respeito
                </p>
              </div>
            </Col>
            <Col lg="6" xl="3">
              <div
                style={{ background: props.white }}
                className="ideology-card"
              >
                <div className="ideology-icon-visao" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  NOSSA VISÃO
                </h3>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Ser a maior em número de vidas no RS e estar presente em dois
                  estados até 2027
                </p>
              </div>
            </Col>
            <Col lg="6" xl="3">
              <div
                style={{ background: props.white }}
                className="ideology-card"
              >
                <div className="ideology-icon-valores" />
                <h3
                  style={{
                    color: props.titleColor,
                    fontSize: props.subTitleSize,
                  }}
                >
                  NOSSOS VALORES
                </h3>
                <p style={{ color: props.textColor, fontSize: props.textSize }}>
                  Humanização, Ética, Excelência, Inovação e Valorização
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}
